<script setup lang="ts">
import { type Link, type NavigationItem } from './types';
import { ChevronRightIcon } from '@heroicons/vue/outline';
import { type HTMLAttributes } from 'vue';

defineProps<{
  items: NavigationItem[];
  title: string;
  link?: Link;
  activeItem: NavigationItem | null;
  stateKey?: 'activeSubNavigation' | 'activeSubNavigation2' | 'activeSubNavigation3';
  class?: HTMLAttributes['class'];
}>();

const { selectNavigationLink } = useNavigation();
</script>

<!-- TODO: Fix accessibility when selecting option, at the moment you have to tab through all to get to it, this can be better I think -->
<template>
  <div class="flex h-full flex-col border-l-1 border-gainsboro pl-5 text-stormcloud" :class="class">
    <nuxt-link v-if="link?.href" :to="link.href" :target="link.target" class="font-semibold hover:bg-gainsboro">
      <NavigationMenuLink class="flex cursor-pointer flex-row items-center justify-between px-4 py-2">
        {{ link?.title }} <ChevronRightIcon class="size-3 stroke-3" />
      </NavigationMenuLink>
    </nuxt-link>

    <template v-else>
      <span v-if="title" class="px-4 py-2 font-semibold">{{ title }}</span>
    </template>

    <ul class="flex flex-col" :aria-expanded="true" :aria-label="`${title} submenu`">
      <li
        v-for="item in items"
        :key="item.title"
        class="text-stormcloud transition-colors hover:bg-gainsboro"
        :class="{ 'bg-tangerine !text-gunmetal hover:bg-tangerine': activeItem === item }"
      >
        <NavigationMenuLink
          v-if="!item.href && stateKey"
          class="flex cursor-pointer flex-row items-center justify-between px-4 py-2"
          @select="(e: Event) => selectNavigationLink(e, item, stateKey)"
        >
          {{ item.title }}
          <ChevronRightIcon class="size-3 stroke-3" />
        </NavigationMenuLink>

        <nuxt-link v-else :to="item.href" :target="item.target" class="hover:bg-gainsboro">
          <NavigationMenuLink class="flex cursor-pointer flex-row items-center justify-between px-4 py-2">
            {{ item.title }}
            <ChevronRightIcon class="size-3 stroke-3" />
          </NavigationMenuLink>
        </nuxt-link>
      </li>
    </ul>
  </div>
</template>
